
import React from "react";
import MainTasksTable from "./Serving/PriorityTableComponents/MainTasksTable";
import AdminMessagesBanner from "./Serving/AdminMessagesBanner";

import "../style/home.css";

export default function Home() {

    return (
        <>
            <div className="home-2nd-container">
                <AdminMessagesBanner />
                <div>
                    <MainTasksTable/>
                </div>
            </div>
        </>
    );
}

